import React from 'react';
import { useLatest } from '.';

/**
 * Invoke a callback function with some interval
 * @param cb The callback to invoke
 * @param interval The interval between callback invocations. Use `undefined` to stop the flow of callbacks.
 */
export default function useInterval(cb: () => void, interval?: number) {
  // If the callback updates, this ref will too. setInterval will invoke the new callback on the next tick
  // without requiring a remount of the hook
  const ref = useLatest(cb);

  React.useEffect(() => {
    if (interval === undefined) {
      return;
    }

    const handle = setInterval(() => ref.current(), interval);
    return () => clearInterval(handle);
  }, [interval, ref]);
}
